import React, { useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Select, SelectProps } from 'tea-component';
import { getSearcherFilter } from '../utils';

import type { IBaseProps } from '@/pages/intelligence/types/common';

interface ISingleCountrySelectProps extends IBaseProps, SelectProps {
  title?: string;
  // 是否展示button的label
  isShowButtonLabel?: boolean;
  // 模式搜索时，是否同时也匹配code进行搜索
  codeSearchable?: boolean;
}

const SingleCountrySelect: React.FC<ISingleCountrySelectProps> = (props) => {
  const {
    style,
    className,
    title = 'dbi_country',
    isShowButtonLabel = false,
    codeSearchable = true,
    allLocaleSearchable = true,
    disabled = false,
    disabledLabel = '',
    overlayClassName = '',
    footer,
    groups,
    options,
    value,
    onChange,
    onSearch,
    onClose,
    tips,
  } = props;

  const { formatMessage } = useIntl();

  const filter = getSearcherFilter(codeSearchable, allLocaleSearchable);

  const [keyword, setKeyword] = useState('');

  const isNoData = !(options && options?.length > 0);
  const isNoSearchData = !(
    options && options?.filter((option) => filter(keyword, option))?.length > 0
  );

  const handleSearch = (keyword?: string, context?: any) => {
    const keywordTmp = keyword ?? '';
    setKeyword(keywordTmp);
    onSearch?.(keywordTmp, context);
  };

  const handleChange = (valuePayload: string, contextPayload: any) => {
    setKeyword('');
    onChange?.(valuePayload, contextPayload);
  };

  const handleClose = () => {
    onClose?.();
    setKeyword('');
  };

  const buttonUI = (() => {
    const labelUI =
      disabled && disabledLabel ? disabledLabel : formatMessage({ id: title });

    const valueUI = (() => {
      if (disabled) return '';
      if (!value) return '';
      // 没有国家列表数据的时候，展示空字符串，优化国家列表数据加载时，会展示国家code的问题
      if (!options?.length) return '';
      const option = options?.find((item) => item?.value === value);
      return option ? option?.text : value;
    })();

    return (
      <>
        <div className="select-button">
          <div className="select-button-text">{labelUI}</div>
          {valueUI}
        </div>
      </>
    );
  })();

  return (
    <Select
      style={style}
      className={classnames('dbi-composed-single-country-select', className)}
      overlayClassName={classnames(
        'dbi-composed-country-select-overlay dbi-composed-single-country-select-overlay',
        // 添加 overlapClassName 属性，便于不同页面控制样式
        overlayClassName,
        {
          'is-no-data': isNoData,
          'is-no-search-data': isNoSearchData,
          'has-footer': React.isValidElement(footer),
        },
      )}
      placeholder={formatMessage({ id: 'dbi_please_select' })}
      appearance="button"
      listWidth={230}
      listHeight={300}
      disabled={disabled}
      searchable={!isNoData}
      searchPlaceholder={formatMessage({ id: 'dbi_label_search' })}
      filter={filter}
      button={isShowButtonLabel ? buttonUI : undefined}
      footer={footer}
      groups={groups}
      options={options}
      value={value}
      onChange={handleChange}
      onSearch={handleSearch}
      onClose={handleClose}
      tips={
        isNoSearchData && (
          <div className="dbi-market-selector-no-data">
            <span>{tips || formatMessage({ id: 'dbi_no_data' })}</span>
          </div>
        )
      }
    />
  );
};

export default SingleCountrySelect;
